import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureConfigService from 'garaje/services/feature-config';
import type StateService from 'garaje/services/state';

export default class RoombaWrapperRoute extends Route {
  title = 'Rooms · Envoy';
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare state: StateService;
  @service declare featureConfig: FeatureConfigService;

  beforeModel(): void {
    const { workplaceSubscription } = this.state;

    if (!this.state.features?.canAccessRoomsApplication && workplaceSubscription?.cancelled) {
      void this.router.transitionTo('workplace.trial-ended');
    } else if (this.abilities.cannot('visit roomba')) {
      void this.router.transitionTo('unauthorized');
    } else if (!this.featureConfig.isEnabled('rooms.accessRoomsTab')) {
      void this.router.replaceWith('roomba.landing-page');
    }
  }
}
